import React from 'react';
import PropTypes from 'prop-types';

import Numeral, { NumeralTypes } from '../numeral.component';
import CustomNumeral from '../customNumeral.component';

type ReportNumberRendererProps = {
  useCustomDecimalNumber: boolean;
  useBlankZeros: boolean;
  suppressHidingDecimalPlacesForPercentage: boolean;
  format: string;
  value: number | string;
}

export const ReportNumberRenderer = ({
  useCustomDecimalNumber,
  useBlankZeros,
  suppressHidingDecimalPlacesForPercentage,
  format = NumeralTypes.DECIMAL,
  value,
}: ReportNumberRendererProps) => {
  const suppressHidingDecimalPlaces = suppressHidingDecimalPlacesForPercentage
    && format === NumeralTypes.PERCENT_4;

  if (format === NumeralTypes.PERCENT_4) {
    return (
      <div className="column col-2">
        <Numeral
          type={format}
        >
          { value }
        </Numeral>
      </div>
    );
  }

  if (useBlankZeros && !value) {
    return (<div className="column col-2" />);
  }

  const NumeralComponent = useCustomDecimalNumber ? CustomNumeral : Numeral;

  return (
    <div className="column col-2">
      {
        // Ignore props checking, because CustomNumeral and Numeral don't have typescript definitions
        // @ts-ignore
        <NumeralComponent
          type={format}
          suppressHidingDecimalPlaces={suppressHidingDecimalPlaces}
        >
          {value}
        </NumeralComponent>
      }
    </div>
  );
};

ReportNumberRenderer.propTypes = {
  useCustomDecimalNumber: PropTypes.bool,
  useBlankZeros: PropTypes.bool,
  suppressHidingDecimalPlacesForPercentage: PropTypes.bool,
  format: PropTypes.string,
  value: PropTypes.number,
};
